import React from 'react'

import "./Layout.scss"

function Layout({pageName,children}) {
    return (
            <div className='layout'>
                <div className='main-content'>
                    {pageName}
                    {children}
                </div>
            </div>
    )
}

export default Layout